import * as PIXI from "pixi.js";
import gsap from "gsap";
import ServiceLocator from "../../ServiceLocator";
import Button from "../../lib/Button";
import signals from "signals";
import { device_orientation_type } from "../../service/DeviceOrientation";


export default class TutorialPopup extends PIXI.Container
{
    // #region Attributes //

    // private:

    private _disabledBg: PIXI.Sprite = null;
    private _baseWrapper: PIXI.Container = null;
    private _base: PIXI.Sprite = null;
    private _selDot: PIXI.Sprite = null;
    private _prevBtn: Button = null;
    private _nextBtn: Button = null;
    private _continueBtn: Button = null;

    private _arrDot: Array<PIXI.Sprite> = null;

    private _curIndex: number = null;

    private _swipeStartX: number = null;

    // Quick access.
    private _interactionManager: PIXI.InteractionManager = null;

    // Constants.
    private readonly _kMaxSlideCount: number = 4;

    // Signals.
    private _onClosed: signals.Signal = null;

    // #endregion //


    public get onClosed(): signals.Signal { return this._onClosed; }


    // #region Methods //

    // public:

    public constructor()
    {
        super();
    }

    public init(): void
    {
        this._onClosed = new signals.Signal();

        this._interactionManager = ServiceLocator.app.renderer.plugins.interaction as PIXI.InteractionManager;
        this._curIndex = 0;

        this._disabledBg = new PIXI.Sprite( ServiceLocator.resources.tut_bg.texture );
        this._disabledBg.interactive = true;
        this._disabledBg.anchor.set( 0.5 );
        this._disabledBg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this.addChild( this._disabledBg );

        let banner: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.tut_header_base.texture );
        banner.anchor.set( 0.5 );
        banner.position.set( ServiceLocator.app.width * 0.5, 136 );
        this.addChild( banner );
        //
        let title: PIXI.Text = new PIXI.Text( "HOW TO PLAY", { fontFamily: "asap_extrabold", fontSize: 58, fill: 0xffffe0 } );
        title.anchor.set( 0.5 );
        banner.addChild( title );

        this._baseWrapper = new PIXI.Container();
        this._baseWrapper.position.set( ServiceLocator.app.width * 0.5, 617 );
        this.addChild( this._baseWrapper );

        this._base = new PIXI.Sprite( ServiceLocator.resources.tut_module_0.texture );
        this._base.x = -this._base.width * 0.5;
        this._base.y = -this._base.height * 0.5;
        this._base.interactive = true;
        this._baseWrapper.addChild( this._base );

        /*const kTutorialInfo: any = ServiceLocator.resources.game_config.data.tutorial[  this._curIndex ];
        this._title = new PIXI.Text( kTutorialInfo.title, { fontFamily: "asap_semibold", fill: 0x000000, fontSize: 40 } );
        this._title.anchor.x = 0.5;
        this._base.addChild( this._title );

        this._message = new PIXI.Text( kTutorialInfo.message, { fontFamily: "asap_bold", fill: 0xffffff, fontSize: 21, wordWrap: true, align: "center" } );
        this._message.anchor.x = 0.5;
        this._base.addChild( this._message );*/

        this._arrDot = [];
        for ( let i: number = 0; i < this._kMaxSlideCount; ++i )
        {
            let dot: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.tut_dot_base.texture );
            dot.anchor.set( 0.5 );
            dot.position.set( [ 265 - 27, 320 - 27, 320 + 27, 375 + 27 ][ i ], 902 );
            this.addChild( dot );

            this._arrDot.push( dot );
        }

        this._selDot = new PIXI.Sprite( ServiceLocator.resources.tut_dot.texture );
        this._selDot.anchor.set( 0.5 );
        this._selDot.position.copyFrom( this._arrDot[ this._curIndex ].position );
        this.addChild( this._selDot );
        
        this._prevBtn = new Button( { on: "tut_arrow_left" } );
        this._prevBtn.setEnabled( false );
        this._prevBtn.anchor.set( 0.5 );
        this._prevBtn.position.set( 84, 1047 );
        this.addChild( this._prevBtn );

        this._nextBtn = new Button( { on: "tut_arrow_right" } );
        this._nextBtn.anchor.set( 0.5 );
        this._nextBtn.position.set( 555, this._prevBtn.y );
        this.addChild( this._nextBtn );

        this._continueBtn = new Button( { on: "tut_button_continue", pressed: "tut_button_continue_pressed" } );
        this._continueBtn.position.set( ServiceLocator.app.width * 0.5, 1053 );
        this._continueBtn.anchor.set( 0.5 );
        this.addChild( this._continueBtn );

        this._continueBtn.on( "pointertap", this._onContinueBtn_Click, this );
        this._nextBtn.on( "pointertap", this._onNextBtn_Click, this );
        this._prevBtn.on( "pointertap", this._onPrevBtn_Click, this );

        ServiceLocator.app.stage.on( "pointerdown", this.onStage_PointerDown, this );
    }

        private _onContinueBtn_Click(): void
        {
            ServiceLocator.app.stage.off( "pointermove", this.onStage_PointerMove, this );
            ServiceLocator.app.stage.off( "pointerdown", this.onStage_PointerDown, this );
            ServiceLocator.app.stage.off( "pointerup", this.onStage_PointerUp, this );

            this._onClosed.dispatch( this ); 
        }

        private _onPrevBtn_Click(): void
        {
            this._curIndex -= 1;

            this._selDot.position.copyFrom( this._arrDot[ this._curIndex ].position );

            this._prevBtn.setEnabled( this._curIndex > 0 );
            this._nextBtn.setEnabled( true );

            this._base.texture = ServiceLocator.resources[ "tut_module_" + this._curIndex.toString() ].texture;
            
            /*const kTutorialInfo: any = ServiceLocator.resources.game_config.data.tutorial[  this._curIndex ];
            this._title.text = kTutorialInfo.title;
            this._message.text = kTutorialInfo.message;*/
        }

        private _onNextBtn_Click(): void
        {
            this._curIndex += 1;

            this._selDot.position.copyFrom( this._arrDot[ this._curIndex ].position );

            this._nextBtn.setEnabled( this._curIndex < this._kMaxSlideCount - 1 );
            this._prevBtn.setEnabled( true );

            this._base.texture = ServiceLocator.resources[ "tut_module_" + this._curIndex.toString() ].texture;
            
            /*const kTutorialInfo: any = ServiceLocator.resources.game_config.data.tutorial[  this._curIndex ];
            this._title.text = kTutorialInfo.title;
            this._message.text = kTutorialInfo.message;*/
        }

        private onStage_PointerDown(): void
        {
            if ( this._base.getBounds().contains( this._interactionManager.eventData.data.global.x, this._interactionManager.eventData.data.global.y ) )
            {
                this._swipeStartX = this._interactionManager.eventData.data.global.x;
    
                ServiceLocator.app.stage.on( "pointermove", this.onStage_PointerMove, this );
                ServiceLocator.app.stage.on( "pointerup", this.onStage_PointerUp, this );
            }
        }

            private onStage_PointerMove(): void
            {             
                if ( Math.abs( ( this._interactionManager.eventData.data.global.x - this._swipeStartX ) / ServiceLocator.app.root.scale.x ) >= 100 )
                {
                    let isRightSwipe: boolean = this._interactionManager.eventData.data.global.x > this._swipeStartX; 
                    if ( isRightSwipe && this._prevBtn.interactive )
                    {
                        ServiceLocator.audio.playSfx( "ui_button_click" );
                        this._onPrevBtn_Click();
                    }
                    else if ( !isRightSwipe && this._nextBtn.interactive )
                    {

                        ServiceLocator.audio.playSfx( "ui_button_click" );
                        this._onNextBtn_Click();
                    }

                    ServiceLocator.app.stage.off( "pointermove", this.onStage_PointerMove, this );
                    ServiceLocator.app.stage.off( "pointerup", this.onStage_PointerUp, this );
                }
            }

            private onStage_PointerUp(): void
            {
                ServiceLocator.app.stage.off( "pointermove", this.onStage_PointerMove, this );
                ServiceLocator.app.stage.off( "pointerup", this.onStage_PointerUp, this );
            }

    public end(): void
    {
        this._onClosed.dispose();
        this._onClosed = null;

        this.parent.removeChild( this._disabledBg );
        this.destroy( { children: true } );
    }

    public onFirstGameStarted(): void
    {
        ServiceLocator.app.stage.off( "pointerdown", this.onStage_PointerDown, this );

        this._prevBtn.visible = false;
        this._nextBtn.visible = false;
        this._continueBtn.visible = true;
        for ( let dot of this._arrDot )
        {
            dot.visible = false;
        }
        this._selDot.visible = false;
    }

    // #endregion //
}